import { type FC, useEffect, useRef } from 'react';
import { useCountUp } from 'react-countup';

import { useAppSelector } from '@/redux/store';

import { createCountUpLimits, createFormatingFn } from './lib';

import css from './styles.module.scss';

interface TicketCharProps {
  value: string | number;
  duration: number;
  place: number;
}

const TicketChar: FC<TicketCharProps> = ({ value, duration }) => {
  const isAnimationActive = useAppSelector(
    (state) => state.lottery.isLotteryHappeningNow,
  );
  const ref = useRef<HTMLDivElement | null>(null);
  const { start } = useCountUp({
    ...createCountUpLimits(value, isAnimationActive),
    ref: ref,
    formattingFn: createFormatingFn(value),
    useEasing: false,
    duration,
    startOnMount: false,
  });

  useEffect(() => {
    start();
  }, [value]);

  return <div className={css.number} ref={ref}></div>;
};

export { TicketChar };
